/* ── Notification rows ─────────────────────────────────────────────────── */

.notifList {
  margin-bottom: 24px;
}

.notifRow {
  border-bottom: 1px solid var(--border);
}

.notifRow:last-child { border-bottom: none; }

.notifMain {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 0 14px;
}

.notifInfo { flex: 1; }

.rowLabel {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
}

.rowHint {
  font-size: 13.5px;
  color: var(--muted);
  margin-top: 3px;
  line-height: 1.5;
}

/* Mini toggle — matches Toggle.module.css proportions */
.toggle {
  position: relative;
  width: 46px;
  height: 26px;
  flex-shrink: 0;
  cursor: pointer;
  margin-top: 1px;
}

.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.track {
  position: absolute;
  inset: 0;
  background: #bdc1c6;
  border-radius: 26px;
  transition: background 0.2s;
}

.toggle input:checked + .track { background: var(--blue); }

.thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  box-shadow: var(--shadow-sm);
  transition: transform 0.2s;
  pointer-events: none;
}

.toggle input:checked ~ .thumb { transform: translateX(20px); }

/* Sub-options (Reaction + Reply) revealed when row is on */
.subOptions {
  display: flex;
  gap: 8px;
  padding-bottom: 14px;
}

.subOption {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  border: 1.5px solid var(--border);
  border-radius: 20px;
  cursor: pointer;
  background: var(--white);
  transition: border-color 0.15s, background 0.15s, color 0.15s;
  user-select: none;
}

.subOption:hover {
  border-color: var(--blue);
  background: var(--blue-lt);
}

.subOptionOn {
  border-color: var(--blue);
  background: var(--blue);
}

.subOptionOn .subLabel {
  color: var(--white);
}

.emojiIcon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  flex-shrink: 0;
}

.subLabel {
  font-size: 13px;
  font-weight: 500;
  color: var(--ink);
}

/* ── Section divider ───────────────────────────────────────────────────── */

.sectionDivider {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .07em;
  color: var(--muted2);
  margin-bottom: 4px;
}

/* ── Inline section (New PR notification style) ────────────────────────── */

.inlineSection {
  padding: 14px 0 16px;
  border-top: 1px dashed var(--border);
}

.inlineSectionLabel {
  font-size: 13px;
  font-weight: 600;
  color: var(--muted);
  margin-bottom: 10px;
}

/* ── Template picker ───────────────────────────────────────────────────── */

.templateSection {
  margin-bottom: 24px;
}

.sectionLabel {
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 4px;
}

.sectionSubLabel {
  font-size: 13px;
  color: var(--muted);
  line-height: 1.5;
  margin-bottom: 10px;
}

.templateOptions {
  display: flex;
  gap: 10px;
}

.templateOption {
  flex: 1;
  border: 1.5px solid var(--border);
  border-radius: var(--radius);
  padding: 12px 14px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  background: var(--white);
}

.templateOption:hover {
  border-color: var(--blue);
  background: var(--blue-lt);
}

.templateOptionActive {
  border-color: var(--blue);
  background: var(--blue-lt);
}

.templateName {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 2px;
}

.templateDesc {
  font-size: 12px;
  color: var(--muted);
  line-height: 1.4;
}

.templatePreview {
  margin-top: 12px;
  padding: 12px 14px;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 12.5px;
  color: var(--ink2);
  line-height: 1.7;
  font-family: 'Roboto Mono', monospace;
  white-space: pre-wrap;
}

.templatePreviewImg {
  margin-top: 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
  background: var(--white);
}

.templatePreviewImg img {
  display: block;
  width: 100%;
  height: auto;
}

.templatePreviewImg img + img {
  border-top: 1px solid var(--border);
}

/* ── Scoped tagging toggle ─────────────────────────────────────────────── */

.scopeRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding-top: 4px;
}

.scopeInfo { flex: 1; }

.scopeLabel {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
}

.scopeHint {
  font-size: 13.5px;
  color: var(--muted);
  margin-top: 3px;
  line-height: 1.55;
}
